import angular from 'angular';
import GooglePay from './lib/GooglePay';
import config from './env.js';
import StatusHandler from './lib/StatusHandler';
import ClientSocketManager from "./lib/ClientSocketManager";
import PushServiceHandler from "./lib/PushServiceHandler";
import BrowserPushNotifications from "./lib/BrowserPushNotifications";

class Panel {

  constructor ($http, $location, $compile, $stateParams) {
    this.$http = $http;
    this.$location = $location;
    this.$compile = $compile;
    this.$stateParams = $stateParams;
    this.gpay = null;
    this.config = config;
    this.baseUrl = this.config.BASE_URL;

    this.headers = {
      'X-Device-Application' : 1,
      'X-CLIENT-UUID' : this.uuid()
    };

    this.session = {
      CLIENT_AUTH_TOKEN: 'client_auth_token',
      CLIENT_REGISTER: 'client_register',
      CLIENT_SOCKETS: 'client_sockets'
    };

    this.event = {
      LOGGED_IN : 'logged.in',
      LOGGED_OUT : 'logged.out',
      IO_TOKEN: 'io.token',
      IDENTITY: 'identity',
      MESSAGE: 'message',
      TYPING: 'typing',
      NEWS: 'news',
    };

    this.socketAddress = {
      PUSH: 'https://mobile.app.courtmenow.com:3636/push'
    };

    this.responseHandler = new StatusHandler(this);
    let self = this;

    this.registerEvents();

    if (!window.deviceReady) {
      window.deviceReady = true;
      document.addEventListener("deviceready", (e) => {
        self.onDeviceReady(e);
      }, false);
    }

    this.user = {};
    this.sockets = false;
    this.isAuthenticated = false;

    this.globals = {
      pageTitle: 'CourtMeNow Dating',
      css: [],
      script: [],
      lookupData: {}
    };

    if (!this.eventHandlers) {
      this.eventHandlers = {};
    }

    if (this.gpay) {
      this.gpay = new GooglePay();
    }
    this.init();
  }

  init (callback) {
    let auth_key = this.getAuthKey();
    if (auth_key) {
      let auth_expires_at = this.getAuthKeyExpiration();
      if (auth_expires_at) {
        // todo
      }
      this.headers['X-Auth-Token']  = auth_key;
      this.isAuthenticated = true;
    }

    let client_register = this.getUser();

    if (!isset(client_register) || !isset(client_register.screen_name)) {
      client_register = false;
      let expired = false;

      // todo check expiry
      let client_sockets = localStorage.getItem(this.session.CLIENT_SOCKETS);

      if (isset(client_sockets)) {
        client_sockets = JSON.parse(client_sockets);
        this.sockets = client_sockets;
      }

      if (isset(callback) && isset(client_register) && isset(client_sockets)) {
        callback(client_register, client_sockets);
      }

      if (this.isAuthenticated) {
        this.loadSessionInfo(callback);
      }
    }

    if (this.isAuthenticated) {
      if (!this.clientSocketManager) {
        this.clientSocketManager = new ClientSocketManager(this, this.getUser());
      }
  //    this.clientSocketManager.init(this.socketAddress.PUSH, PushServiceHandler);

      $(document).ready( () => {
        let appServerKey = 'BMBlr6YznhYMX3NgcWIDRxZXs0sh7tCv7_YCsWcww0ZCv9WGg-tRCXfMEHTiBPCksSqeve1twlbmVAZFv7GSuj0';
        let serviceUrl = '/v1/subscribe/browser/push';
        this.browserPushNotifications = new BrowserPushNotifications(this, '#push-notifications-button', appServerKey, serviceUrl);
        if (this.browserPushNotifications.supportsPushNotifications()) {
          this.browserPushNotifications.pushSubscribe();
        }
      });
    }
  }

  loadSessionInfo (callback) {
    let user = this.getUser();

    if (isset(user.screen_name)) {
      return;
    }

    const self = this;

    this.get('/v1/account/session', (response) => {
      if (response.Request === 'OK') {
        localStorage.setItem(self.session.CLIENT_REGISTER, JSON.stringify(response.register));
        localStorage.setItem(self.session.CLIENT_SOCKETS, JSON.stringify(response.sockets));
        self.setUser(response.register);
        self.sockets = response.sockets;
        if (isset(callback)) {
          callback(self.user, self.sockets);
        }
      }
    });
  }

  alert (data) {
    if (is_object(data)) {
        data = angular.toJson(data);
    }

    $('<div></div>').appendTo('body')
        .html('<div><h6>' + data + '</h6></div>')
        .dialog({
            modal: true, title: 'message', zIndex: 10000, autoOpen: true,
            width: 'auto', resizable: false,
            buttons: {
                OK () {
                    $(this).dialog("close");
                }
            },

            close (event, ui) {
                $(this).remove();
            }
        });
  }

  confirm (question, yesCallback, title, buttons) {
    if (typeof buttons == 'undefined') {

        buttons = {

            Yes () {
                (yesCallback)();
                $(this).dialog("close");
            },

            No () {
                $(this).dialog("close");
            }
        }
    } else {

        let bts = {};

        bts[buttons['yes']] = function () {
            (yesCallback)();
            $(this).dialog("close");
        };

        bts[buttons['no']] = function () {
            $(this).dialog("close");
        };

        buttons = bts;
    }

    $('<div></div>').appendTo('body')
        .html('<div><h6>' + question + '</h6></div>')
        .dialog({
            modal: true, title: typeof title == 'undefined' ? 'message' : title, zIndex: 10000, autoOpen: true,
            width: '300', resizable: false,
            buttons: buttons,
            close (event, ui) {
                $(this).remove();
            }
        });
  }

  okay (response) {
      return response.Request && response.Request === 'OK';
  }

  handle (response) {
    if (response.message) {
      this.dashboard_error(response.message);
    }
  }

  validateEmail (email) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return (true)
    }
    this.alert("You have entered an invalid email address!");
    return (false)
  }

  activity () {
    return {
        VIEW: 1,
        LIKE: 2,
        FAVORITE: 3,
        MESSAGE: 4,
        CHAT_REQUEST: 5,
        FOLLOW: 6,
        REGISTRATION: 7,
        MEETUP_REQUEST: 12,
        ACCEPT_MEETUP_REQUEST: 13,
        MEETUP_SCHEDULE_UPDATE: 14,
        MEETUP_SCHEDULE_ACCEPT: 15,
        MEETUP_SCHEDULE_CANCELLED: 16,
        DISCUSSION_COMMENT: 17,
        FLAG: 18,
    };
  }

  getConfig () {
      return this.config;
  }

  getHashedUrl () {
    return location.hash.substring(2).split('/');
  }

  limit (str, limit) {
    return str.substr(0, limit);
  }

  paragraph (str) {
    return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }

  getUrlParams () {
    let vars = {}, hash;
    if (window.location.href.indexOf('?') > -1) {
      let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

      for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars[hash[0]] = decodeURIComponent(hash[1].replace(/\+/g, ' '));
      }
    }
    return vars;
  }

  getParam (name) {

      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");

      let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search),
        answer = results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));

      if (answer === "") {
          results = regex.exec(this.getHashedUrl());
          answer = results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
      }

      return answer;
  }

  get (path, callback, err) {
    let url = this.baseUrl+path;
    let headers = this.headers;
    this.$http({
        method: 'GET',
        url,
        headers
    })
      .then( (response) => {
            if (isset(callback)) {
                (callback)(response.data)
            }
        },
        (error) => {
            if (err) {
                err (error);
            } else {
                this.responseHandler.handle(error, callback);
            }
      });
  }

  back () {
      window.history.back();
  }

  post (url, formData, callback, err, show_loader) {
    url = this.baseUrl+url;

    if (show_loader) {
        $('body').append('<div id="loading-gif"><i class="fa fa-circle-o-notch"></i></div>');
    }

    let headers = this.headers;

    headers['Content-Type'] = 'application/x-www-form-urlencoded';
    this.$http({
        method: 'POST',
        url,
        data: $.param(formData),
        headers
    })
      .then( (response) => {

            if (show_loader) {
                $("#loading-gif").remove()
            }

            if (isset(callback)) {
                (callback)(response.data)
            }
        },
        (error) => {

            if (show_loader) {
                $("#loading-gif").remove()
            }

            if (err) {
                err (error);
            } else {
                this.responseHandler.handle(error, callback);
            }
      });

  }

  getRequestHeaders () {
      return this.headers;
  }

  getBaseUrl () {
      return this.baseUrl;
  }

  login (token) {
    localStorage.setItem('client_auth_token', JSON.stringify(token));
    const self = this;
    this.init(() => {
      self.isAuthenticated = true;
      self.emitEvent(self.event.LOGGED_IN, token);
    });

  }

  hasCompletedProfile () {
    let user = this.getUser();
    return parseInt(user.has_completed_profile) !== 0;
  }

  setHasCompletedProfile(isComplete) {
    let user = this.getUser();
    user.has_completed_profile = isComplete;
    localStorage.setItem(this.session.CLIENT_REGISTER, JSON.stringify(user));
  }

  hasCompletedMatch () {
    let user = this.getUser();
    return parseInt(user.has_completed_match) !== 0;
  }

  setHasCompletedMatch(isComplete) {
    let user = this.getUser();
    user.has_completed_match = isComplete;
    localStorage.setItem(this.session.CLIENT_REGISTER, JSON.stringify(user));
  }

  logout () {
    const self = this;
    this.confirm('Are you sure you want to sign out?', () => {
      let logoutURL = "/v1/account/logout";
      // let isSocial = this.register.facebook_id ? true : false;
      self.post(logoutURL, {}, (response) => {
        localStorage.removeItem(self.session.CLIENT_AUTH_TOKEN);
        localStorage.removeItem(self.session.CLIENT_REGISTER);
        localStorage.removeItem(self.session.CLIENT_SOCKETS);
        self.emitEvent(self.event.LOGGED_OUT, response);
      });
    });
  }

  getAuthToken () {
    let auth_token = localStorage.getItem('client_auth_token');
    if (auth_token === undefined || auth_token === 'undefined') {
      return false;
    }
    return JSON.parse(auth_token);
  }

  getAuthKey () {
    let token = this.getAuthToken();
    if (token) {
        return token.auth_key;
    }
    return false;
  }

  getAuthKeyExpiration () {
    let token = this.getAuthToken();
    if (token) {
        return token.expires_at;
    }
    return false;
  }

  setSocketIOToken(token, handlerName) {
    if (!this.socketIOTokens) {
      this.socketIOTokens = {};
    }
    this.socketIOTokens[handlerName] = token;
    localStorage.setItem(handlerName, token);
  }

  getSocketIOToken(handlerName) {
    if (this.socketIOTokens && this.socketIOTokens.hasOwnProperty(handlerName)) {
      return this.socketIOTokens[handlerName];
    }
    return localStorage.getItem(handlerName);
  }

  isLoggedIn () {
    return this.isAuthenticated;
  }

  setUser (user) {
    this.user = user;
  }

  getUser () {
    if (isset(this.user.screen_name)) {
      return this.user;
    }
    let user = localStorage.getItem(this.session.CLIENT_REGISTER);
    if (isset(user)) {
      user = JSON.parse(user);
      this.setUser(user);
    }
    return this.user;
  }

  goto (url) {
    history.pushState(null, null, url);
  }

  checkAuth ($state) {
    let auth_key = this.getAuthKey();
    if ($state && $state.current && $state.current.authRequired) {
      if (!auth_key) {
        console.log('You must be logged in to access this service');
        history.pushState(null, null, '/');
      }
    }
    if (!auth_key) {
      //location.href = '/';
      //history.pushState(null, null, '/');
    }
  }

  log (data, type) {
    type = type ? type : 'info';
    if (this.env === ENV_DEVELOPMENT) {
      console.log(type + ': ', data);
    }
  }

  getSocketManager () {
    return this.clientSocketManager;
  }

  uuid () {
    let uid = localStorage.getItem('client_uuid');
    if (uid) {
        return uid;
    }
    let d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
        d += performance.now(); //use high-precision timer if available
    }
    uid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        uid = (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        return uid;
    });
    localStorage.setItem('client_uuid', uid);
    return uid;
    }

    profilePhoto () {
        let user = this.getUser();
        if(user.profile)
        return this.baseUrl+user.image_url+user.profile.photo+'?_=t';
    }

    dashboard_message (message) {
      console.log(message);
    }

    dashboard_error (message) {

    }

    account_deleted_redirect () {
        window.location.href = '';
    }

    upload (url, formData, callback) {

        url = this.baseUrl+url;

        this.$http.post(
            url,
            formData,
            {
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            }
        )
            .success(function (response) {

                if (isset(callback)) {
                    (callback)(response)
                }
            })
    }

    serializeObject (serializedArray) {

        let o = {};

        let a = serializedArray;

        $.each(a, function () {

            if (o[this.name] !== undefined) {

                if (!o[this.name].push) {

                    o[this.name] = [o[this.name]];

                }

                o[this.name].push(this.value || '');

            } else {

                o[this.name] = this.value || '';
            }
        });

        return o;
    }

    range (start, end) {

        return Array(end - start).join(0).split(0).map(function (val, id) {
            return (id + start).toString()
        });
    }

    isMobile () {

        let isMobile = false;

        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;

        return isMobile;
    }

    popup_init (popup, scope, callback) {

        let html = $(popup);

        this.$compile(html)(scope);

        $("body").append(html);

        $(".popup-cancel").each(function () {

            $(this).click(function () {
                $(".inline-popup").remove();
            })
        });

        $('.popup-target').draggable();

        if (isset(callback)) {
            (callback)();
        }

        $(document).keyup(function (e) {

            if (e.keyCode === 13) $('.popup-action').click();

            if (e.keyCode === 27) $(".inline-popup").remove();
        });

        $('html,body').click(function (e) {
            let exitPopup = $(e.target).hasClass('inline-popup');
            exitPopup && $('.popup-cancel').click();
        });
    }

    popup_remove () {
        $(".inline-popup").remove();
    }

    xy () {
        let success = false;

        const self = this;
        if (navigator.geolocation && location.protocol === 'https:') {

            navigator.geolocation.getCurrentPosition(function (position) {

                let data = {location: 1};

                data.latitude = position.coords.latitude;

                data.longitude = position.coords.longitude;

                self.post('/v1/account/location', data, function (response) {

                    if (self.okay(response)) {
                        success = true;
                    }
                });

            }, function (error) {

                switch (error.code) {

                    case error.PERMISSION_DENIED:
                        // console.log("User denied the request for Geolocation.");
                        break;

                    case error.POSITION_UNAVAILABLE:
                        // console.log("Location information is unavailable.");
                        break;

                    case error.TIMEOUT:
                        // console.log("The request to get user location timed out.");
                        break;

                    case error.UNKNOWN_ERROR:
                        // console.log("An unknown error occurred.");
                        break;
                }

                self.post('/v1/account/location', {location: 0}, function (response) {
                    success = false;
                });
            });
        }

        return success;
    }

    is_actioned (activity, register_id, matches) {

        let activities = [];

        for (let j in matches) {
            if (matches[j].register_id == register_id) {
                activities = matches[j].activity;
                break;
            }
        }

        for (let i in activities) {
            if (activities[i]['activity_id'] == activity) {
                return true;
            }
        }

        return false;
    }

    get_option_items (item, description, options) {

        let things = options ? options[description] : {};

        for (let i in things) {

            if (things[i]['id'] == item) {

                return things[i]['description'];
            }
        }
    }

    runWsCallbacks (namespace, callback) {
        if (isset(callback)) {
            return (callback)(this.ws[namespace]);
        }
        if (this.wsQueue) {
            for (let i in this.wsQueue) {
                if (i == namespace) {
                    for (let j in this.wsQueue[i]) {
                        (this.wsQueue[i][j])(this.ws[namespace]);
                    }
                }
            }
        }
    }

    registerWSObject (namespace, ws) {
        if (!this.ws) {
            this.ws = {};
            this.ws[namespace] = ws;
        }
        this.runWsCallbacks(namespace);
        this.wsCallbacksRun = true;
    }

    getWSObject (namespace, callback) {
        if (!this.wsQueue) {
            this.wsQueue = {};
            this.wsQueue[namespace] = [callback];
        } else if (this.wsCallbacksRun) {
            this.runWsCallbacks(namespace, callback);
        } else {
            this.wsQueue[namespace].push(callback);
        }
    }

    loading (selector) {
        $(selector).prepend($("<div class='loading-spinner'><i class='fa fa-refresh fa-spin fa-fw'></i></div>"));
        $('.loading-spinner').css({
            position: 'absolute',
            'z-index': 999,
            background: 'rgba(255,255,255,0.8)',
            width: '100%',
            height: $(selector).height(),
            'line-height': $(selector).height() + 'px',
            'vertical-align': 'middle',
            'text-align': 'center',
            'font-size': '2.5em',
            color: 'rgba(0,0,0,0.4)'
        });
    }

    unload (selector) {
        $(selector).find('.loading-spinner').remove();
    }

    setTitle (title) {

    }

    getTitle () {
        return 'Court Me Now Dating';
    }

    getLanguage () {
        return 'en';
    }

    hasAccess (feature) {
        return true;
    }

    createEvent (eventName, data) {
        let event = null;
        if (window.CustomEvent) {
            event = new CustomEvent(eventName, data);
        } else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventName, true, true, data);
        }
        return event;
    }

    registerEvents () {
        document.addEventListener(this.event.LOGGED_OUT, (e) => {
            localStorage.removeItem('client_auth_token');
            window.location.href = '';
        }, false);
    }

    registerEvent (eventName, callback) {
        document.addEventListener(eventName, (e) => {
            if(callback){
                callback(e);
            }
        });
    }

    emitEvent (eventName, data) {
        if (typeof data !== 'object') {
            data = {'detail' : data};
        } else if (!data.detail) {
            data = {detail: data};
        }

        let event = this.createEvent(eventName, data);
        document.dispatchEvent(event);
    }

    onDeviceReady (e) {
        try {
            // console.log(navigator.notification);
            // console.log(navigator.camera);
            // console.log(device.cordova);
            // console.log(e);
        } catch(err) {
            // console.log(err);
        }
    }

    loadFacebook() {
        (function(d, s, id) {var js, fjs = d.getElementsByTagName(s)[0];if (d.getElementById(id)) return;js = d.createElement(s); js.id = id;js.src = "//connect.facebook.net/en_US/sdk.js";fjs.parentNode.insertBefore(js, fjs);}(document, 'script', 'facebook-jssdk'));
    }

    loadCaptcha() {
        (function(d, s, id) {var js, fjs = d.getElementsByTagName(s)[0];if (d.getElementById(id)) return;js = d.createElement(s); js.id = id;js.src = "//www.google.com/recaptcha/api.js";fjs.parentNode.insertBefore(js, fjs);}(document, 'script', 'google-captcha'));
    }

    popupModal (el) {
      let elem = new Foundation.Reveal(el, []);
      elem.open();
      el.find('[data-close]').click(()=>{
        elem.close();
      });
      return elem;
    }

    action (match, popup_id) {
      let self = this;

      return {
        do (activity) {
          if (!match.hasOwnProperty('register_id')) {
            return;
          }
          if (activity === self.activity().MESSAGE) {
            self.emitEvent('current.match.set', match);
            let el = $('#'+popup_id);
            self.popupModal(el);
          } else if (activity === self.activity().FLAG) {
            let el = $('#'+popup_id);
            self.popupModal(el);
          } else {
            self.post('/v1/matches/activity', {activity_id:activity, register_id:match.register_id}, (response) => {
              if (self.okay(response)) {
                match.activity.push(response.activity);
                self.dashboard_message("Action successful.");
              }
            });
          }
        },

        undo (activity) {
          let activities = match.activity;
          let act = null;
          let index = 0;

          for (let j in activities) {
            if(activities[j].activity_id === activity){
              index = j;
              act = activities[j];
              break;
            }
          }

          if (act != null) {
            self.post('/v1/matches/activity', {log_id:act.id, activity_id:activity, register_id:match.register_id, undo:true}, (response) => {
              if (self.okay(response)){
                match.activity.splice(index, 1);
              }
            });
          }
        },

        isDone (activity) {
          let activities = match.activity;
          for (let i in activities) {
            if (parseInt(activities[i]['activity_id']) === activity) return true;
          }
          return false;
        }
      }
    }
}

export default angular.module('panel', []).service('panel', Panel).name;

// The panel service was made part of root here
// MyApp.run(function($rootScope, panel){$rootScope.panel = panel;});



// WEBPACK FOOTER //
// ./src/app/services.js